import React, { FC } from 'react'

import Link from '../../components/Link/Link'
import { kebabCase } from 'lodash'
import styled from '@emotion/styled'

const Tag = styled.div`
  display: flex;
`

const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  text-transform: uppercase;
`
export const TagLink = styled(Link)`
  margin-bottom: 0.5rem;
  :hover {
    color: ${({ theme }) => theme.color.link};
  }
`

export type TagsProps = {
  tags: GatsbyTypes.MarkdownRemarkFrontmatter['tags']
}

const Tags: FC<TagsProps> = ({ tags = [] }) => {
  const tagLength = tags.length
  return tagLength > 0 ? (
    <TagList>
      {tags.map((tag, i) => (
        <Tag key={tag}>
          <TagLink to={`/tags/${kebabCase(tag)}/`}>{tag}</TagLink>
          {i !== tagLength - 1 && (
            <div style={{ paddingRight: '8px', marginBottom: '0.5rem' }}>,</div>
          )}
        </Tag>
      ))}
    </TagList>
  ) : null
}

export default Tags
